import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Socio from "./components/Socio";
import Login from "./components/Login";
import SignUp from "./components/SignUp";
import MiPago from "./components/MiPago"; // si ya lo tienes

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />

      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />

      <Route path="/socio" element={<Socio />} />
      <Route path="/mi-pago" element={<MiPago />} />

      {/* fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
